import styled from 'styled-components';
import {
  buttonStyle, color, space, layout, typography,
} from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby-plugin-intl';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

interface ColorProps {
  primary?: number,
  secondary?: number
}

export const InternalLink = styled(Link).withConfig(
  fixPropWarnings('primary', 'secondary', 'minwidth'),
)<ColorProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0.2px;
  height: 38px;
  width: 100%;
  min-width: 110px;
  max-width: 163px;
  text-align: center;
  font-weight: ${(props) => props.theme.fontWeights.medium};

  color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.white');
    if (secondary) return themeGet('colors.blacks.1');
    return '';
  }};
  background-color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.blacks.1');
    if (secondary) return themeGet('colors.white');
    return '';
  }};
  border: ${({ secondary }) => {
    if (secondary) return '2px solid black';
    return '';
  }};

  :lang(fr) {
    line-height: 13px;
    padding: 0 1rem;
  }

  :hover,
  :focus {
    color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.white');
    if (secondary) return themeGet('colors.reds.1');
    return '';
  }};
    background-color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.reds.1');
    if (secondary) return themeGet('colors.white');
    return '';
  }};
  }

  ${color}
  ${buttonStyle}
  ${space}
  ${layout}
  ${typography}
`;

export const ExternalLink = styled.a
  .attrs(() => ({
    target: '_blank',
    rel: 'noopener noreferrer',
  }))
  .withConfig(fixPropWarnings('primary', 'secondary', 'minwidth'))<ColorProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0.2px;
  height: 38px;
  width: 100%;
  text-align: center;
  min-width: 110px;
  max-width: 163px;
  font-weight: ${(props) => props.theme.fontWeights.medium};

  color: ${(props) => {
    if (props.primary) return themeGet('colors.white');
    if (props.secondary) return themeGet('colors.blacks.1');
    return '';
  }};
  background-color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.blacks.1');
    if (secondary) return themeGet('colors.white');
    return '';
  }};
  border: ${({ secondary }) => {
    if (secondary) return '2px solid black';
    return '';
  }};

  :lang(fr) {
    line-height: 13px;
    padding: 0 1rem;
  }

  :hover,
  :focus {
    color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.white');
    if (secondary) return themeGet('colors.blacks.1');
    return '';
  }};
    background-color: ${({ primary, secondary }) => {
    if (primary) return themeGet('colors.blacks.1');
    if (secondary) return themeGet('colors.white');
    return '';
  }};
  }

  ${color}
  ${buttonStyle}
  ${space}
  ${layout}
  ${typography}
`;
